(() => {
  const observed = new WeakSet();
  const context = document.createElement('canvas').getContext('2d');
  const fit = async root => {
    const text = root.querySelector('.mdh-cart-preview__name');
    const family = getComputedStyle(text).fontFamily;
    try { await document.fonts.load(`100px ${family}`); } catch (_) {}
    if (!root.isConnected) return;
    context.font = `100px ${family}`;
    const measurement = context.measureText(text.textContent);
    const width = Math.max(measurement.width, (measurement.actualBoundingBoxLeft || 0) + (measurement.actualBoundingBoxRight || 0));
    const x = Number(root.dataset.nameX);
    const available = Math.min(text.clientWidth, root.clientWidth * Math.min(x, 100 - x) * .02) * .98;
    const maxSize = root.clientWidth * Number(root.dataset.nameSize) / 100;
    text.style.fontSize = `${width ? Math.min(maxSize, available * 100 / width) : maxSize}px`;
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => fit(entry.target)));
  const init = () => document.querySelectorAll('[data-mdh-cart-preview]').forEach(root => {
    if (observed.has(root)) return;
    observed.add(root);
    resize.observe(root);
    fit(root);
  });
  new MutationObserver(init).observe(document.documentElement, {childList:true, subtree:true});
  init();
})();
